import type { BenefitCardFragment } from '@/lib/types/datocms/graphql/generated'
import Image from 'next/image'

export default function BenefitCard({ title, icon }: Readonly<BenefitCardFragment>) {
	return (
		<div className="bg-blue rounded-lg p-6">
			{icon && (
				<Image
					src={icon.url}
					alt={icon.alt ?? 'Benefit Icon'}
					className="w-9"
					width={100}
					height={100}
					sizes="36px"
				/>
			)}
			{title && <h3 className="text-white mt-16 lg:mt-20 text-lg font-semibold">{title}</h3>}
		</div>
	)
}
